import { render, staticRenderFns } from "./lowPriceRealTimeOperateAdmin.vue?vue&type=template&id=5aa25119&scoped=true"
import script from "./lowPriceRealTimeOperateAdmin.vue?vue&type=script&lang=js"
export * from "./lowPriceRealTimeOperateAdmin.vue?vue&type=script&lang=js"
import style0 from "./lowPriceRealTimeOperateAdmin.vue?vue&type=style&index=0&id=5aa25119&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa25119",
  null
  
)

export default component.exports